export default {"src":"/_next/static/media/logo-768x338.a1d6ef3e.svg","height":41,"width":95,"blurWidth":0,"blurHeight":0};